import React, { Component } from 'react';
import AlbumForm from '../AlbumForm/Container'
import Modal from '../Modal'
import { Uploader, UploadField } from '@navjobs/upload'
import {serverUrl} from '../../utils/restUtils'
import {Link} from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import './albums.css'
class Home extends Component {

    constructor(props){
	super(props)
	this.state = {modalVisible: null}
    }
    
    componentDidMount(){
	this.props.loadAlbums()
    }
    
    render() {
	const {albums, authenticated, updateAlbum, removeAlbum} = this.props
	const {modalVisible} = this.state
	
	const toggleModal = (data) => {
	    let {modalVisible} = this.state
	    modalVisible = data
	    this.setState({modalVisible})
	}

	return (
	    <div>
		
		<h1>Albumi</h1>
		{ authenticated ?
		  <button className="btn btn-brown btn-big full-width" onClick={() => toggleModal({})}><i className="fa fa-plus"></i> Dodaj album</button>
		  : null}
		<div className="albums">
		    {albums.map(a => <div key={a.id} className="albumLink">
			{authenticated  ?
			 <div className="adminSection">
			     <ReactTooltip />
			     {authenticated ? <button style={{float: 'left'}}  data-tip="Spremeni"  className="btn" onClick={() => toggleModal(a)}><i className="fa fa-edit"></i></button> : null}
			     {authenticated ? <button style={{float: 'right'}} data-tip="Zbriši"  className="btn" onClick={()=>removeAlbum(a.id)}><i className="fa fa-remove"></i></button> : null}
			     
			     <div style={{clear: 'both'}}></div>
			 </div>
			: null}
			<Link to={`/albums/${a.id}`}>
			    <img src={a.image_url} />
			    <div className="title">{a.name}</div>
			</Link>
		    </div>)}
		</div>

		<Modal toggleModal={() => toggleModal(false)} visible={modalVisible}>
		    <h2>Dodaj album</h2>
		    <AlbumForm successAction={toggleModal}  initialValues={modalVisible} />
		</Modal>
		
		
	    </div>
	);
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Albums/index.jsx